import { MainBookmakerMappingDetail as MainBookmakerMappingDetailComponent } from './MainBookmakerMappingDetail.component';
import { connector } from './MainBookmakerMappingDetail.connector';

export const MainBookmakerMappingDetail = connector(MainBookmakerMappingDetailComponent);
